$(function () {
    // Ouve o submit para mostrar imediatamente o loading (antes do reCAPTCHA)
    $(document).on('submit', '.loadingForm', function () {
        const $submitBtn = $(this).find('button[type="submit"]');
        if ($submitBtn.prop('disabled')) return;

        $submitBtn.data('original', $submitBtn.html());
        $submitBtn.html(`
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Aguarde...
        `).prop('disabled', true);
    });

    // Quando o recaptcha terminar (seja sucesso ou erro), restaura o botão
   document.addEventListener('sac:finished', function (ev) {
        if (!ev.detail?.formId) return;
        $('.loadingForm').each(function() {
            const $btn = $(this).find('button[type="submit"]');
            const original = $btn.data('original') || 'Enviar';
            $btn.html(original).prop('disabled', false);
        });
    });
});
